module.exports = __webpack_public_path__ + "static/media/outIcon.e4511c06.svg";